
























































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import data from "@/services/data/vita-investimento";
import categories from "@/services/categories";
import ComboBox from "@/components/ComboBox.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { PnetInput } from "@previnet/vue-input";
import moment from "moment";
import { isNil } from 'ramda';
import { it } from "vuejs-datepicker/dist/locale";
import {propertyTypes} from "@/services/properties";
import properties, {codes} from "@/services/properties/vita-investimento";
import { format } from "date-fns";
import Header from "@/components/Header.vue";
import {PnetDatatable} from '@previnet/vue-datatable';
import jquery from 'jquery';
import Datatable from 'datatables.net';
import responsive from 'datatables.net-responsive';
import fixedHeader from 'datatables.net-fixedheader-dt';
import fixedColumns from 'datatables.net-fixedcolumns-dt';
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js'
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css'
import 'datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4.min.js'
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'
import 'datatables.net-fixedcolumns-bs4/js/fixedColumns.bootstrap4.min.js'
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css'
import config from "@/services/config";
import { mapGetters } from 'vuex';
import { Filter } from '@/services/filters';

const FILTER_KEY = "vita-investimento-database";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user','filters','fromDashboard'],
  components: {
    PnetDatePicker,
    PnetInput,
    ComboBox,
    Header,
    MultiComboBox,
    PnetDatatable
  },
  computed: {
    ...mapGetters('filters', {
      filterById: 'byId',
    })
  },
  data: function() {
    return {
      config,
      fixedColumns,
      fixedHeader,
      jquery,
      loggedUser: this.$props.user,
      codCategoriaProdotto: categories.VITA_INVESTIMENTO,
      listaProdottiCensiti: [] as any[],
      listaProdottiCensitiForTable: [] as any[],
      listaProdottiCensitiPaginati: [] as any[],
      listaProdottiCensitiCurrent: [] as any[],
      filterOptions: {
        prodottoCompleto: [] as any[],
        prodotto: [] as any[],
        compagnia: [] as any[],
        mercato: [] as any[],
        canale: [] as any[],
        distributori: [] as any[],
        tipologiaProdotto: [] as any[],
        tipologiaSottostanti: [] as any[],
        prodottoInCommercio: [] as any[],
        tipologiaPremio: [] as any[],
        ramoISFDR: [] as any[],
        ramoIIIPresenzaFondiInterniArt8SFDR: [] as any[],
        ramoIIIPresenzaFondiInterniArt9SFDR: [] as any[],
        ramoIIIPresenzaOICRETFArt8SFDR: [] as any[],
        ramoIIIPresenzaOICRETFArt9SFDR: [] as any[],
      } as any,
      changedFilterFields: [],
      options: {
        fixedHeader: true,
        fixedColumns: {
          leftColumns: 0
        },
        responsive: true,
        paging: false,
        scrollX: true,
        scrollY: "500px",
        scrollCollapse: true,
        dom: 'lfrti',
        searching: false,
        info: false,
        autoWidth: true,
        order: [4, "asc"],
        language: {
          emptyTable: 'Nessun prodotto censito',
          info: '_START_ - _END_ di _TOTAL_',
          infoEmpty: '',
        }
      },
      page: 1,
      totPages: 1,
      needsPagination: false,
      itemsPerPage: 20,
      pageStart: 1,
      pageEnd: 20,
      columns: [
        {
          label: '',
          field: 'isSelected',
          render: function(data: any, type: any, row: any) {
            return "<input type='checkbox' id='isSelectedProd_"+row.id+"' name='isSelectedProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Seleziona prodotto' class='selectProd' value='true' />";
          },
          className: 'text-center',
          tag: 'caratteristiche_generali',
        },
        {
          label: 'Visualizza',
          modalLabel: 'Visualizza',
          field: 'isToModify',
          render: function(data: any, type: any, row: any) {
            //const m = "<button id='isToModifyProd_"+row.id+"' name='isToModifyProd_"+row.id+"' data-toggle='tooltip' title='Modifica prodotto' class='btn btn-table p-1 pl-2 modifyProd'><i class='fa fa-pencil-square-o' aria-hidden='true'></i></button>";-->
            const s = "<button id='isToShowProd_"+row.id+"' name='isToShowProd_"+row.id+"' data-toggle='tooltip' data-placement='right' title='Visualizza prodotto' class='btn btn-table p-1 showProd'><i class='fa fa-search' aria-hidden='true'></i></button>";
            
            //return m + s;
            return s;
          },
          className: 'text-center',
        },
        {
          label: 'Prodotto completo',
          modalLabel: 'Prodotto completo',
          field: 'prodottoCompleto',
          render: function(data: any, type: any, row: any) {
            return data ? "Sì" : "No";
          },
          className: 'text-center',
          checkVisible: true,
        },
        {
          label: 'Codice prodotto',
          modalLabel: 'Codice prodotto',
          field: 'productCode',
          checkVisible: true,
        },
        {
          label: 'Prodotto',
          modalLabel: 'Prodotto',
          field: 'prodotto',
          width: '300px',
          orderable: true,
          modalShowHidden: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Più versioni prodotto',
          modalLabel: 'Più versioni prodotto',
          field: 'piuVersioniProdotto',
          width: '300px',
        },
        {
          label: 'Codice prodotti collegati',
          modalLabel: 'Codice prodotti collegati',
          field: 'codiceProdottiCollegati',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true
        },
        {
          label: 'Compagnia',
          modalLabel: 'Compagnia',
          field: 'compagnia',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Mercato',
          modalLabel: 'Mercato',
          field: 'mercato',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Canale',
          modalLabel: 'Canale',
          field: 'canale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Distributori',
          modalLabel: 'Distributori',
          field: 'distributori',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia prodotto',
          modalLabel: 'Tipologia prodotto',
          field: 'tipologiaProdotto',
          width: '300px',
          orderable: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia sottostanti',
          modalLabel: 'Tipologia sottostanti',
          field: 'tipologiaSottostanti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Prodotto in commercio',
          modalLabel: 'Prodotto in commercio',
          field: 'prodottoInCommercio',
          width: '300px',
        },
        {
          label: 'Inizio commercializzazione',
          modalLabel: 'Inizio commercializzazione',
          field: 'inizioCommercializzazione',
          width: '300px',
          orderable: true,
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fine commercializzazione',
          modalLabel: 'Fine commercializzazione',
          field: 'fineCommercializzazione',
          width: '300px',
          orderable: true,
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Edizione DIP aggiuntivo',
          modalLabel: 'Edizione DIP aggiuntivo',
          field: 'edizioneDIPAggiuntivo',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia premio',
          modalLabel: 'Tipologia premio',
          field: 'tipologiaPremio',
          width: '300px',
          tag: 'requisiti_sottoscrizione',
          leftborder: true,
          sectionName: 'REQUISITI DI SOTTOSCRIZIONE',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Durata contrattuale',
          modalLabel: 'Durata contrattuale',
          field: 'durataContrattuale',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Durata piano pagamento premi',
          modalLabel: 'Durata piano pagamento premi',
          field: 'durataPianoPagamentoPremi',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio unico - \nimporto minimo',
          modalLabel: 'Premio unico - importo minimo',
          field: 'importoMinPremioUnico',
          width: '300px',
          orderable: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio unico - \nimporto massimo',
          modalLabel: 'Premio unico - importo massimo',
          field: 'importoMaxPremioUnico',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio ricorrente (annuo) - \nimporto minimo',
          modalLabel: 'Premio ricorrente (annuo) - importo minimo',
          field: 'importoMinPremioRicAnnuo',
          width: '300px',
          orderable: true,
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Premio ricorrente (annuo) - \nimporto massimo',
          modalLabel: 'Premio ricorrente (annuo) - importo massimo',
          field: 'importoMaxPremioRicAnnuo',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Target market',
          modalLabel: 'Target market',
          field: 'targetMarket',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Orizzonte temporale suggerito',
          modalLabel: 'Orizzonte temporale suggerito',
          field: 'orizzonteTemporaleSuggerito',
          width: '300px',
          tag: 'indicatori_kid',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'KID',
          leftborder: true,
        },
        {
          label: 'Indicatore sintetico di rischio',
          modalLabel: 'Indicatore sintetico di rischio',
          field: 'indicatoreSinteticoRischio',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Reduction in Yield - \ncosti di ingresso',
          modalLabel: 'Reduction in Yield - costi di ingresso',
          field: 'reductionInYieldCostiIngresso',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
        },
        {
          label: 'Reduction in Yield - \ncosti di uscita',
          modalLabel: 'Reduction in Yield - costi di uscita',
          field: 'reductionInYieldCostiUscita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Reduction in Yield - \ncosti correnti',
          modalLabel: 'Reduction in Yield - costi correnti',
          field: 'reductionInYieldCostiCorrenti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Asset Allocation',
          modalLabel: 'Asset Allocation',
          field: 'assetAllocation',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'INVESTIMENTO',
          leftborder: true,
        },
        {
          label: 'Gestione Separata - \ninvestimento minimo',
          modalLabel: 'Investimento minimo',
          field: 'invMinGestioneSeparata',
          width: '300px',
          tag: 'investimento_gestione_separata',
          sectionName: 'INVESTIMENTO IN GESTIONE SEPARATA',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Gestione Separata - \ninvestimento massimo',
          modalLabel: 'Investimento massimo',
          field: 'invMaxGestioneSeparata',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Gestione Separata',
          modalLabel: 'Gestione Separata',
          field: 'gestioneSeparata',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rendimento Gestione Separata',
          modalLabel: 'Rendimento Gestione Separata',
          field: 'rendimentoGestioneSeparata',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rendimento minimo garantito - \ntipologia',
          modalLabel: 'Rendimento minimo garantito',
          field: 'rendMinGarantito',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rendimento minimo garantito - \nmisura',
          modalLabel: 'Rendimento minimo garantito - misura',
          field: 'rendMinGarantitoMisura',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza consolidamento annuo delle rivalutazioni contrattuali',
          modalLabel: 'Presenza consolidamento annuo delle rivalutazioni contrattuali',
          field: 'presenzaConsolidamentoAnnuoRivalutazioniContrattuali',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Consolidamento annuo rivalutazioni contrattuali',
          modalLabel: 'Consolidamento annuo rivalutazioni contrattuali',
          field: 'consolidamentoAnnuoRivalutazioniContrattuali',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fondo utili',
          modalLabel: 'Fondo utili',
          field: 'fondoUtili',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ramo III - \ninvestimento minimo',
          modalLabel: 'Investimento minimo',
          field: 'invMinRamoIII',
          width: '300px',
          tag: 'investimento_ramoIII',
          sectionName: 'INVESTIMENTO IN RAMO III',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Ramo III - \ninvestimento massimo',
          modalLabel: 'Investimento massimo',
          field: 'invMaxRamoIII',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Numero Fondi Interni',
          modalLabel: 'Numero Fondi Interni',
          field: 'numFondiInterni',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia Fondi Interni',
          modalLabel: 'Tipologia Fondi Interni',
          field: 'tipologiaFondiInterni',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Numero OICR/ETF',
          modalLabel: 'Numero OICR/ETF',
          field: 'numOICRETF',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza protezione del capitale',
          modalLabel: 'Presenza protezione del capitale',
          field: 'presenzaProtezioneCapitale',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Protezione del capitale',
          modalLabel: 'Protezione del capitale',
          field: 'protezioneCapitale',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Opzioni contrattuali',
          modalLabel: 'Tipologia',
          field: 'opzioniContrattualiTipologia',
          width: '300px',
          tag: 'opzioni',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'OPZIONI CONTRATTUALI',
          leftborder: true,
        },
        {
          label: 'Cedola',
          modalLabel: 'Cedola',
          field: 'cedola',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Decumulo',
          modalLabel: 'Decumulo',
          field: 'decumulo',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Rendita',
          modalLabel: 'Rendita',
          field: 'rendita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Stop Loss',
          modalLabel: 'Stop Loss',
          field: 'stopLoss',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Take Profit',
          modalLabel: 'Take Profit',
          field: 'takeProfit',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Progressive Investment',
          modalLabel: 'Progressive Investment',
          field: 'progressiveInvestment',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Automatic Rebalance',
          modalLabel: 'Automatic Rebalance',
          field: 'automaticRebalance',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Downtrend Opportunity',
          modalLabel: 'Downtrend Opportunity',
          field: 'downtrendOpportunity',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Life Cycle',
          modalLabel: 'Life Cycle',
          field: 'lifeCycle',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre opzioni contrattuali',
          modalLabel: 'Altre opzioni contrattuali',
          field: 'altreOpzioniContrattuali',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Garanzie assicurative',
          modalLabel: 'Tipologia',
          field: 'garanzieAssicurativeTipologia',
          width: '300px',
          tag: 'garanzie',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'GARANZIE ASSICURATIVE',
          leftborder: true,
        },
        {
          label: 'Maggiorazione caso morte standard - \ntipologia',
          modalLabel: 'Maggiorazione caso morte standard',
          field: 'maggiorazioneCasoMorteStandard',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte standard - \nprestazione',
          modalLabel: 'Maggiorazione caso morte standard - prestazione',
          field: 'maggiorazioneCasoMorteStandardPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per infortunio - \ntipologia',
          modalLabel: 'Maggiorazione caso morte per infortunio',
          field: 'maggiorazioneCasoMortePerInfortunio',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per infortunio - \nprestazione',
          modalLabel: 'Maggiorazione caso morte per infortunio - prestazione',
          field: 'maggiorazioneCasoMortePerInfortunioPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per incidente stradale - \ntipologia',
          modalLabel: 'Maggiorazione caso morte per incidente stradale',
          field: 'maggiorazioneCasoMortePerIncidenteStradale',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per incidente stradale - \nprestazione',
          modalLabel: 'Maggiorazione caso morte per incidente stradale - prestazione',
          field: 'maggiorazioneCasoMortePerIncidenteStradalePrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per minusvalenza - \ntipologia',
          modalLabel: 'Maggiorazione caso morte per minusvalenza',
          field: 'maggiorazioneCasoMortePerMinusvalenza',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Maggiorazione caso morte per minusvalenza - \nprestazione',
          modalLabel: 'Maggiorazione caso morte per minusvalenza - prestazione',
          field: 'maggiorazioneCasoMortePerMinusvalenzaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'TCM stand alone - \ntipologia',
          modalLabel: 'TCM stand alone',
          field: 'TCMStandAlone',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'TCM stand alone - \nprestazione',
          modalLabel: 'TCM stand alone - prestazione',
          field: 'TCMStandAlonePrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Long Term Care - \ntipologia',
          modalLabel: 'Long Term Care',
          field: 'longTermCare',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Long Term Care - \nprestazione',
          modalLabel: 'Long Term Care - prestazione',
          field: 'longTermCarePrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Dread Disease - \ntipologia',
          modalLabel: 'Dread Disease',
          field: 'dreadDisease',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Dread Disease - \nprestazione',
          modalLabel: 'Dread Disease - prestazione',
          field: 'dreadDiseasePrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità/Inabilità - \ntipologia',
          modalLabel: 'Invalidità/Inabilità',
          field: 'invaliditaInabilita',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Invalidità/Inabilità - \nprestazione',
          modalLabel: 'Invalidità/Inabilità - prestazione',
          field: 'invaliditaInabilitaPrestazione',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altre garanzie assicurative',
          modalLabel: 'Altre garanzie assicurative',
          field: 'altreGaranzieAssicurative',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia bonus d\'ingresso',
          modalLabel: 'Tipologia bonus d\'ingresso',
          field: 'tipologiaBonusIngresso',
          width: '300px',
          tag: 'bonus',
          sectionName: 'BONUS',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Bonus d\'ingresso',
          modalLabel: 'Bonus d\'ingresso',
          field: 'bonusIngresso',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia bonus fedeltà',
          modalLabel: 'Tipologia bonus fedeltà',
          field: 'tipologiaBonusFedelta',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Bonus fedeltà',
          modalLabel: 'Bonus fedeltà',
          field: 'bonusFedelta',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese di emissione',
          modalLabel: 'Spese di emissione',
          field: 'speseEmissione',
          width: '300px',
          tag: 'costi',
          sectionName: 'COSTI',
          leftborder: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia caricamento PIC (%)',
          modalLabel: 'Tipologia caricamento PIC (%)',
          field: 'tipologiaCaricamentoPIC',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Caricamento PIC (%)',
          modalLabel: 'Caricamento PIC (%)',
          field: 'caricamentoPIC',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia caricamento PAC (%)',
          modalLabel: 'Tipologia caricamento PAC (%)',
          field: 'tipologiaCaricamentoPAC',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Caricamento PAC (%)',
          modalLabel: 'Caricamento PAC (%)',
          field: 'caricamentoPAC',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Caricamento (€)',
          modalLabel: 'Caricamento (€)',
          field: 'caricamento',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia commissione Gestione Separata',
          modalLabel: 'Tipologia commissione Gestione Separata',
          field: 'tipologiaCommissioneGestioneSeparata',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Gestione Separata',
          modalLabel: 'Commissione Gestione Separata',
          field: 'commissioneGestioneSeparata',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia commissione Fondi Interni',
          modalLabel: 'Tipologia commissione Fondi Interni',
          field: 'tipologiaCommissioneFondiInterni',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Fondi Interni - \nazionari',
          modalLabel: 'Commissione Fondi Interni azionari',
          field: 'commissioneFondiInterniAzionari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Fondi Interni - \nobbligazionari',
          modalLabel: 'Commissione Fondi Interni obbligazionari',
          field: 'commissioneFondiInterniObbligazionari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Fondi Interni - \nbilanciati',
          modalLabel: 'Commissione Fondi Interni bilanciati',
          field: 'commissioneFondiInterniBilanciati',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Fondi Interni - \nflessibili',
          modalLabel: 'Commissione Fondi Interni flessibili',
          field: 'commissioneFondiInterniFlessibili',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione Fondi Interni - \nmonetari',
          modalLabel: 'Commissione Fondi Interni monetari',
          field: 'commissioneFondiInterniMonetari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione sottostanti Fondi Interni',
          modalLabel: 'Commissione sottostanti Fondi Interni',
          field: 'commissioneSottostantiFondiInterni',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tipologia spese gestione polizza (OICR/ETF)',
          modalLabel: 'Tipologia spese gestione polizza (OICR/ETF)',
          field: 'tipologiaSpeseGestionePolizzaOICRETF',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese gestione polizza OICR/ETF - \nazionari',
          modalLabel: 'Spese gestione polizza OICR/ETF azionari',
          field: 'speseGestionePolizzaOICRETFAzionari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese gestione polizza OICR/ETF - \nobbligazionari',
          modalLabel: 'Spese gestione polizza OICR/ETF obbligazionari',
          field: 'speseGestionePolizzaOICRETFObbligazionari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese gestione polizza OICR/ETF - \nbilanciati',
          modalLabel: 'Spese gestione polizza OICR/ETF bilanciati',
          field: 'speseGestionePolizzaOICRETFBilanciati',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese gestione polizza OICR/ETF - \nflessibili',
          modalLabel: 'Spese gestione polizza OICR/ETF flessibili',
          field: 'speseGestionePolizzaOICRETFFlessibili',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Spese gestione polizza OICR/ETF - \nmonetari',
          modalLabel: 'Spese gestione polizza OICR/ETF monetari',
          field: 'speseGestionePolizzaOICRETFMonetari',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissione OICR/ETF',
          modalLabel: 'Commissione OICR/ETF',
          field: 'commissioneOICRETF',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Applicazione commissioni di overperformance',
          modalLabel: 'Applicazione commissioni di overperformance',
          field: 'applicazioneCommissioniOverperformance',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissioni di overperformance',
          modalLabel: 'Commissioni di overperformance',
          field: 'commissioniOverperformance',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Costo maggiorazione caso morte standard (%)',
          modalLabel: 'Costo maggiorazione caso morte standard (%)',
          field: 'costoMaggiorazioneCasoMorteStandard',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Riscatto',
          modalLabel: 'Riscatto',
          field: 'riscatto',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Applicazione commissioni di uscita',
          modalLabel: 'Applicazione commissioni di uscita',
          field: 'applicazioneCommissioniUscita',
          width: '300px',
          checkVisible: true,
          modalShowHidden: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Commissioni di uscita (%)',
          modalLabel: 'Commissioni di uscita (%)',
          field: 'commissioniUscita',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Altri costi',
          modalLabel: 'Altri costi',
          field: 'altriCosti',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \ncaricamento (%)',
          modalLabel: 'Caricamento (%)',
          field: 'retrocessioneCaricamento',
          width: '300px',
          tag: 'retrocessione',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          sectionName: 'RETROCESSIONE ALLA DISTRIBUZIONE',
          leftborder: true,
        },
        {
          label: 'Retrocessione alla distribuzione - \nGestione Separata',
          modalLabel: 'Gestione Separata',
          field: 'retrocessioneGestioneSeparata',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Retrocessione alla distribuzione - \nRamo III',
          modalLabel: 'Ramo III',
          field: 'retrocessioneRamoIII',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Sostenibilità
        {
          label: 'Polizza sostenibile ai sensi degli Artt. 8-9 SFDR',
          modalLabel: 'Polizza sostenibile ai sensi degli Artt. 8-9 SFDR',
          field: 'sostenibilita',
          width: '300px',
          tag: 'sostenibilita',
          leftborder: true,
          sectionName: "SOSTENIBILITA'",
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'SFDR',
          modalLabel: 'SFDR',
          field: 'ramoISFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tassonomia UE',
          modalLabel: 'Tassonomia UE',
          field: 'ramoITassonomiaUE',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Allocazione attivi',
          modalLabel: 'Allocazione attivi',
          field: 'ramoIAllocazioneAttivi',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'PAI',
          modalLabel: 'PAI',
          field: 'ramoIPAI',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza Fondi Interni Art. 8 SFDR',
          modalLabel: 'Presenza Fondi Interni Art. 8 SFDR',
          field: 'ramoIIIPresenzaFondiInterniArt8SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'N° Fondi Interni Art. 8 SFDR',
          modalLabel: 'N° Fondi Interni Art. 8 SFDR',
          field: 'ramoIIINumFondiInterniArt8SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fondi Interni Art. 8 SFDR (%)',
          modalLabel: 'Fondi Interni Art. 8 SFDR (%)',
          field: 'ramoIIIFondiInterniArt8SFDRPerc',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tassonomia UE Fondi Interni Art. 8',
          modalLabel: 'Tassonomia UE Fondi Interni Art. 8',
          field: 'ramoIIITassonomiaUEFondiInterniArt8',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Allocazione attivi Fondi Interni Art. 8',
          modalLabel: 'Allocazione attivi Fondi Interni Art. 8',
          field: 'ramoIIIAllocazioneAttiviFondiInterniArt8',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza Fondi Interni Art. 9 SFDR',
          modalLabel: 'Presenza Fondi Interni Art. 9 SFDR',
          field: 'ramoIIIPresenzaFondiInterniArt9SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'N° Fondi Interni Art. 9 SFDR',
          modalLabel: 'N° Fondi Interni Art. 9 SFDR',
          field: 'ramoIIINumFondiInterniArt9SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Fondi Interni Art. 9 SFDR (%)',
          modalLabel: 'Fondi Interni Art. 9 SFDR (%)',
          field: 'ramoIIIFondiInterniArt9SFDRPerc',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tassonomia UE Fondi Interni Art. 9',
          modalLabel: 'Tassonomia UE Fondi Interni Art. 9',
          field: 'ramoIIITassonomiaUEFondiInterniArt9',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Allocazione attivi Fondi Interni Art. 9',
          modalLabel: 'Allocazione attivi Fondi Interni Art. 9',
          field: 'ramoIIIAllocazioneAttiviFondiInterniArt9',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'PAI Fondi Interni',
          modalLabel: 'PAI Fondi Interni',
          field: 'ramoIIIPAIFondiInterni',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza OICR/ETF Art. 8 SFDR',
          modalLabel: 'Presenza OICR/ETF Art. 8 SFDR',
          field: 'ramoIIIPresenzaOICRETFArt8SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'N° OICR/ETF Art. 8 SFDR',
          modalLabel: 'N° OICR/ETF Art. 8 SFDR',
          field: 'ramoIIINumOICRETFArt8SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'OICR/ETF Art. 8 SFDR (%)',
          modalLabel: 'OICR/ETF Art. 8 SFDR (%)',
          field: 'ramoIIIOICRETFArt8SFDRPerc',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tassonomia UE OICR/ETF Art. 8',
          modalLabel: 'Tassonomia UE OICR/ETF Art. 8',
          field: 'ramoIIITassonomiaUEOICRETFArt8',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Presenza OICR/ETF Art. 9 SFDR',
          modalLabel: 'Presenza OICR/ETF Art. 9 SFDR',
          field: 'ramoIIIPresenzaOICRETFArt9SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'N° OICR/ETF Art. 9 SFDR',
          modalLabel: 'N° OICR/ETF Art. 9 SFDR',
          field: 'ramoIIINumOICRETFArt9SFDR',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'OICR/ETF Art. 9 SFDR (%)',
          modalLabel: 'OICR/ETF Art. 9 SFDR (%)',
          field: 'ramoIIIOICRETFArt9SFDRPerc',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'Tassonomia UE OICR/ETF Art. 9',
          modalLabel: 'Tassonomia UE OICR/ETF Art. 9',
          field: 'ramoIIITassonomiaUEOICRETFArt9',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        {
          label: 'PAI OICR/ETF',
          modalLabel: 'PAI OICR/ETF',
          field: 'ramoIIIPAIOICRETF',
          width: '300px',
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
        },
        // Note
        {
          label: 'Note',
          modalLabel: 'Note',
          field: 'note',
          width: '300px',
          html: true,
          render: function(data: any, type: any, row: any) {
            if (data != undefined && data['printableValue']) {
              if (data['tooltipValue']) {
                return "<div data-toggle='tooltip' data-html='true' data-placement='left' title='" + data['tooltipValue'] + "'>" + data['printableValue'] + "</div>";
              }

              return data['printableValue'];
            }

            return "";
          },
          leftborder: true,
          sectionName: '',
        },
      ],
      tags: [
        { tag: 'caratteristiche_generali', label: 'Caratteristiche generali' },
        { tag: 'requisiti_sottoscrizione', label: 'Requisiti di sottoscrizione' },
        { tag: 'indicatori_kid', label: 'KID' },
        { tag: 'investimento_gestione_separata', label: 'Investimento in Gestione Separata' },
        { tag: 'investimento_ramoIII', label: 'Investimento in Ramo III' },
        { tag: 'opzioni', label: 'Opzioni' },
        { tag: 'garanzie', label: 'Garanzie' },
        { tag: 'bonus', label: 'Bonus' },
        { tag: 'costi', label: 'Costi' },
        { tag: 'retrocessione', label: 'Retrocessione' },
        { tag: 'sostenibilita', label: 'Sostenibilità' },
      ],
      headers: {
        supergroups: [
          {
            key: 0,
            label: '',
            colspan: 4,
          },
          {
            key: 1,
            label: 'Caratteristiche generali',
            colspan: 13,
          },
          {
            key: 2,
            label: 'Requisiti di sottoscrizione',
            colspan: 8,
          },
          {
            key: 3,
            label: 'Indicatori KID',
            colspan: 5,
          },
          {
            key: 4,
            label: 'Investimento',
            colspan: 18,
          },
          {
            key: 5,
            label: 'Opzioni contrattuali',
            colspan: 11,
          },
          {
            key: 6,
            label: 'Garanzie assicurative',
            colspan: 18,
          },
          {
            key: 7,
            label: 'Bonus',
            colspan: 4,
          },
          {
            key: 8,
            label: 'Costi',
            colspan: 29,
          },
          {
            key: 9,
            label: 'Retrocessione alla distribuzione',
            colspan: 3,
          },
          {
            key: 10,
            label: '',
            colspan: 1,
            leftborder: true,
          },
        ],
        groups: [
          {
            key: 0,
            label: '',
            colspan: 4,
          },
          {
            key: 1,
            label: '',
            colspan: 13,
            leftborder: true,
          },
          {
            key: 2,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 3,
            label: 'Premio unico',
            colspan: 2,
          },
          {
            key: 4,
            label: 'Premio ricorrente (annuo)',
            colspan: 2,
          },
          {
            key: 5,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 6,
            label: '',
            colspan: 2,
            leftborder: true,
          },
          {
            key: 7,
            label: 'Reduction in yield',
            colspan: 3,
          },
          {
            key: 8,
            label: '',
            colspan: 1,
            leftborder: true,
          },
          {
            key: 9,
            label: 'Investimento in gestione separata',
            colspan: 10,
          },
          {
            key: 10,
            label: 'Investimento in Ramo III',
            colspan: 7,
          },
          {
            key: 11,
            label: '',
            colspan: 11,
            leftborder: true,
          },
          {
            key: 12,
            label: '',
            colspan: 18,
            leftborder: true,
          },
          {
            key: 13,
            label: '',
            colspan: 4,
            leftborder: true,
          },
          {
            key: 14,
            label: '',
            colspan: 29,
            leftborder: true,
          },
          {
            key: 15,
            label: '',
            colspan: 3,
            leftborder: true,
          },
          {
            key: 16,
            label: '',
            colspan: 1,
            leftborder: true,
          },
        ],
      },
      filtroRicerca: {
        prodottoCompleto: null,
        prodotto: [] as any,
        compagnia: [] as any,
        mercato: [] as any,
        canale: [] as any,
        distributori: [] as any,
        tipologiaProdotto: [] as any,
        tipologiaSottostanti: [] as any,
        prodottoInCommercio: null,
        inizioCommercializzazioneDaDate: undefined,
        inizioCommercializzazioneADate: undefined,
        fineCommercializzazioneDaDate: undefined,
        fineCommercializzazioneADate: undefined,
        inizioCommercializzazioneDa: undefined,
        inizioCommercializzazioneA: undefined,
        fineCommercializzazioneDa: undefined,
        fineCommercializzazioneA: undefined,
        tipologiaPremio: [] as any,
        impMinPremioUnicoDa: undefined,
        impMinPremioUnicoA: undefined,
        impMinPremioRicorrenteDa: undefined,
        impMinPremioRicorrenteA: undefined,
        ramoISFDR: [] as any,
        ramoIIIPresenzaFondiInterniArt8SFDR: null,
        ramoIIIPresenzaFondiInterniArt9SFDR: null,
        ramoIIIPresenzaOICRETFArt8SFDR: null,
        ramoIIIPresenzaOICRETFArt9SFDR: null,
      },
      operationToConfirm: "",
      msgError: "",
      msgSuccess: "",
      msgConfirmOperation: "",
      it,
      ...data,
      ...properties,
      propertyTypes,
      prodottiOptions: [] as any,
      distributoriOptions: [] as any,
      compagnieOptions: [] as any,
      ND: "n.d.",
      product: {} as any,
      productName: "",
      scrollTables: null as any,
      selectAll: false,
    };
  },
  methods: {
    storeFilter: function(filter: any) {
      var f: Filter = {
        id: FILTER_KEY,
        payload: filter !== undefined ? filter : this.filtroRicerca,
        changedFields: {},
        viewState: {},
      }
      this.$store.dispatch('filters/set', f);
    },
    getStoredFilter: function() {
      const f: Filter = this.filterById(FILTER_KEY);
      if (f == undefined) {
        return undefined;
      }

      return f.payload;
    },
    resetFilterOptions: async function() {
      const vm = this as any;

      vm.filterOptions.prodottoCompleto = vm.yesNoOptions;
      vm.filterOptions.prodotto = vm.prodottiOptions;
      vm.filterOptions.compagnia = vm.compagnieOptions;
      vm.filterOptions.mercato = vm.mercatoOptions;
      vm.filterOptions.canale = vm.canaleOptions;
      vm.filterOptions.distributori = vm.distributoriOptions;
      vm.filterOptions.tipologiaProdotto = vm.tipologiaProdottoOptions;
      vm.filterOptions.tipologiaSottostanti = vm.tipologiaSottostantiOptions;
      vm.filterOptions.prodottoInCommercio = vm.yesNoOptions;
      vm.filterOptions.tipologiaPremio = vm.tipologiaPremioOptions;
      vm.filterOptions.ramoISFDR = vm.ramoISFDROptions;
      vm.filterOptions.ramoIIIPresenzaFondiInterniArt8SFDR = vm.yesNoOptions;
      vm.filterOptions.ramoIIIPresenzaFondiInterniArt9SFDR = vm.yesNoOptions;
      vm.filterOptions.ramoIIIPresenzaOICRETFArt8SFDR = vm.yesNoOptions;
      vm.filterOptions.ramoIIIPresenzaOICRETFArt9SFDR = vm.yesNoOptions;
    },
    emptyNoDynamicFiltroRicerca: async function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
      vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
      vm.filtroRicerca.fineCommercializzazioneADate = undefined;
      vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
      vm.filtroRicerca.inizioCommercializzazioneA = undefined;
      vm.filtroRicerca.fineCommercializzazioneDa = undefined;
      vm.filtroRicerca.fineCommercializzazioneA = undefined;
      vm.filtroRicerca.impMinPremioUnicoDa = undefined;
      vm.filtroRicerca.impMinPremioUnicoA = undefined;
      vm.filtroRicerca.impMinPremioRicorrenteDa = undefined;
      vm.filtroRicerca.impMinPremioRicorrenteA = undefined;
    },
    emptyFilterOptions: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filterOptions.prodottoCompleto = []; 
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filterOptions.prodotto = [];
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filterOptions.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filterOptions.mercato = [];
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filterOptions.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filterOptions.distributori = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
          vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
        vm.filterOptions.tipologiaProdotto = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
          vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
        vm.filterOptions.tipologiaSottostanti = [];
      }      
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filterOptions.prodottoInCommercio = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaPremio') ||
          vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
        vm.filterOptions.tipologiaPremio = [];
      }
      if (!vm.changedFilterFields.includes('ramoISFDR') ||
          vm.changedFilterFields.indexOf('ramoISFDR') > indexOfChangedField) {
        vm.filterOptions.ramoISFDR = [];
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaFondiInterniArt8SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaFondiInterniArt8SFDR') > indexOfChangedField) {
        vm.filterOptions.ramoIIIPresenzaFondiInterniArt8SFDR = []; 
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaFondiInterniArt9SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaFondiInterniArt9SFDR') > indexOfChangedField) {
        vm.filterOptions.ramoIIIPresenzaFondiInterniArt9SFDR = []; 
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaOICRETFArt8SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaOICRETFArt8SFDR') > indexOfChangedField) {
        vm.filterOptions.ramoIIIPresenzaOICRETFArt8SFDR = []; 
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaOICRETFArt9SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaOICRETFArt9SFDR') > indexOfChangedField) {
        vm.filterOptions.ramoIIIPresenzaOICRETFArt9SFDR = []; 
      }
    },
    emptyFiltroRicerca: async function(indexOfChangedField: number) {
      const vm = this as any;

      if (!vm.changedFilterFields.includes('prodottoCompleto') ||
          vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
        vm.filtroRicerca.prodottoCompleto = null;
      }
      if (!vm.changedFilterFields.includes('prodotto') ||
          vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
        vm.filtroRicerca.prodotto = []
      }
      if (!vm.changedFilterFields.includes('compagnia') ||
          vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
        vm.filtroRicerca.compagnia = [];
      }
      if (!vm.changedFilterFields.includes('mercato') ||
          vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
        vm.filtroRicerca.mercato = undefined;
      }
      if (!vm.changedFilterFields.includes('canale') ||
          vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
        vm.filtroRicerca.canale = [];
      }
      if (!vm.changedFilterFields.includes('distributori') ||
          vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
        vm.filtroRicerca.distributori = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
          vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaProdotto = [];
      }
      if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
          vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaSottostanti = [];
      }
      if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
          vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
        vm.filtroRicerca.prodottoInCommercio = null;
      }
      if (!vm.changedFilterFields.includes('tipologiaPremio') ||
          vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
        vm.filtroRicerca.tipologiaPremio = [];
      }
      if (!vm.changedFilterFields.includes('ramoISFDR') ||
          vm.changedFilterFields.indexOf('ramoISFDR') > indexOfChangedField) {
        vm.filtroRicerca.ramoISFDR = [];
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaFondiInterniArt8SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaFondiInterniArt8SFDR') > indexOfChangedField) {
        vm.filtroRicerca.ramoIIIPresenzaFondiInterniArt8SFDR = null;
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaFondiInterniArt9SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaFondiInterniArt9SFDR') > indexOfChangedField) {
        vm.filtroRicerca.ramoIIIPresenzaFondiInterniArt9SFDR = null;
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaOICRETFArt8SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaOICRETFArt8SFDR') > indexOfChangedField) {
        vm.filtroRicerca.ramoIIIPresenzaOICRETFArt8SFDR = null;
      }
      if (!vm.changedFilterFields.includes('ramoIIIPresenzaOICRETFArt9SFDR') ||
          vm.changedFilterFields.indexOf('ramoIIIPresenzaOICRETFArt9SFDR') > indexOfChangedField) {
        vm.filtroRicerca.ramoIIIPresenzaOICRETFArt9SFDR = null;
      }
    },
    emptyChangedFilterFields() {
      const vm = this as any;

      vm.changedFilterFields = [];
    },
    resetFilterOptionsAndEmptyFiltroRicerca() {
      const vm = this as any;

      vm.resetFilterOptions();
      vm.emptyNoDynamicFiltroRicerca();
      vm.emptyFiltroRicerca(-1);
      vm.emptyChangedFilterFields();
      vm.storeFilter();
    },
    repopulateFiltersOptionsChangedCompagnia: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('compagnia');
    },
    repopulateFiltersOptionsChangedMercato: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('mercato');
    },
    repopulateFiltersOptionsChangedProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('prodotto');
    },
    repopulateFiltersOptionsChangedDistributori: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('distributori');
    },
    repopulateFiltersOptionsChangedCanale: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('canale');
    },
    repopulateFiltersOptionsChangedTipologiaProdotto: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaProdotto');
    },
    repopulateFiltersOptionsChangedTipologiaSottostanti: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaSottostanti');
    },
    repopulateFiltersOptionsChangedTipologiaPremio: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('tipologiaPremio');
    },
    repopulateFiltersOptionsChangedRamoISFDR: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('ramoISFDR');
    },
    repopulateFiltersOptionsChangedRamoIIIPresenzaFondiInterniArt8SFDR: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('ramoIIIPresenzaFondiInterniArt8SFDR');
    },
    repopulateFiltersOptionsChangedRamoIIIPresenzaFondiInterniArt9SFDR: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('ramoIIIPresenzaFondiInterniArt9SFDR');
    },
    repopulateFiltersOptionsChangedRamoIIIPresenzaOICRETFArt8SFDR: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('ramoIIIPresenzaOICRETFArt8SFDR');
    },
    repopulateFiltersOptionsChangedRamoIIIPresenzaOICRETFArt9SFDR: async function() {
      const vm = this as any;

      vm.repopulateFiltersOptions('ramoIIIPresenzaOICRETFArt9SFDR');
    },
    repopulateFiltersOptions: async function(changedFieldName: string) {
      const vm = this as any;

      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean

      // mantenere l'ordine!
      if (!vm.changedFilterFields.includes(changedFieldName)) {
        vm.changedFilterFields.push(changedFieldName);
      }
      const indexOfChangedField = vm.changedFilterFields.indexOf(changedFieldName)
      vm.emptyFilterOptions(indexOfChangedField);
      vm.emptyFiltroRicerca(indexOfChangedField);
      if (indexOfChangedField + 1 < vm.changedFilterFields.length) {
        vm.changedFilterFields.splice(indexOfChangedField+1, (vm.changedFilterFields.length-indexOfChangedField+1));
      }
      if (vm.filtroRicerca[changedFieldName] === undefined ||
          vm.filtroRicerca[changedFieldName] === null ||
          vm.filtroRicerca[changedFieldName].length == 0) {
        vm.changedFilterFields.pop();
      }
      //console.log(JSON.stringify(vm.filtroRicerca[changedFieldName]));
      //console.log(indexOfChangedField  + " " + changedFieldName + " vm.changedFilterFields " + JSON.stringify(vm.changedFilterFields));

      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {

              // Prodotto completo
              if (!vm.changedFilterFields.includes('prodottoCompleto') ||
                  vm.changedFilterFields.indexOf('prodottoCompleto') > indexOfChangedField) {
                let filterProdottoCompletoOption = { code : vm.listaProdottiCensiti[i].completed , value : (vm.listaProdottiCensiti[i].completed ? "Sì" : "No" ) };
                vm.pushOptionValue(filterProdottoCompletoOption,vm.filterOptions.prodottoCompleto);
              }

              // Prodotto
              if (!vm.changedFilterFields.includes('prodotto') ||
                  vm.changedFilterFields.indexOf('prodotto') > indexOfChangedField) {
                let filterProdottoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodottoProperty);
                vm.pushOptionValueProdotto(filterProdottoOption,vm.filterOptions.prodotto);
              }

              // Compagnia
              if (!vm.changedFilterFields.includes('compagnia') ||
                  vm.changedFilterFields.indexOf('compagnia') > indexOfChangedField) {
                let filterCompagniaOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.compagniaProperty);
                vm.pushOptionValue(filterCompagniaOption,vm.filterOptions.compagnia);
              }

              // Mercato
              if (!vm.changedFilterFields.includes('mercato') ||
                  vm.changedFilterFields.indexOf('mercato') > indexOfChangedField) {
                let filterMercatoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.mercatoProperty);
                vm.pushOptionValues(filterMercatoOption,vm.filterOptions.mercato);
              }

              // Canale
              if (!vm.changedFilterFields.includes('canale') ||
                  vm.changedFilterFields.indexOf('canale') > indexOfChangedField) {
                let filterCanaleOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.canaleProperty);
                vm.pushOptionValues(filterCanaleOption,vm.filterOptions.canale);
              }

              // Distributori
              if (!vm.changedFilterFields.includes('distributori') ||
                  vm.changedFilterFields.indexOf('distributori') > indexOfChangedField) {
                let filterDistributoriOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.distributoriProperty);
                vm.pushOptionStringList(filterDistributoriOption,vm.filterOptions.distributori,'distributori');
              }

              // Tipologia prodotto
              if (!vm.changedFilterFields.includes('tipologiaProdotto') ||
                  vm.changedFilterFields.indexOf('tipologiaProdotto') > indexOfChangedField) {
                let filterTipologiaProdottoOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaProdottoProperty);
                vm.pushOptionValue(filterTipologiaProdottoOption,vm.filterOptions.tipologiaProdotto);
              }

              // Tipologia sottostanti
              if (!vm.changedFilterFields.includes('tipologiaSottostanti') ||
                  vm.changedFilterFields.indexOf('tipologiaSottostanti') > indexOfChangedField) {
                let filterTipologiaSottostantiOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaSottostantiProperty);
                vm.pushOptionValues(filterTipologiaSottostantiOption,vm.filterOptions.tipologiaSottostanti);
              }

              // Prodotto in commercio
              if (!vm.changedFilterFields.includes('prodottoInCommercio') ||
                  vm.changedFilterFields.indexOf('prodottoInCommercio') > indexOfChangedField) {
                const prodCommercioProperty = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodCommercioProperty);
                let filterProdottoInCommercioOption = { code : (prodCommercioProperty.code == "8.1" ? true : false) , value : prodCommercioProperty.value };
                vm.pushOptionValue(filterProdottoInCommercioOption,vm.filterOptions.prodottoInCommercio);
              }

              // Tipologia premio
              if (!vm.changedFilterFields.includes('tipologiaPremio') ||
                  vm.changedFilterFields.indexOf('tipologiaPremio') > indexOfChangedField) {
                let filterTipologiaPremioOption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaPremioProperty);
                vm.pushOptionValue(filterTipologiaPremioOption,vm.filterOptions.tipologiaPremio);
              }

              // SFDR Gestione Separata
              if (!vm.changedFilterFields.includes('ramoISFDR') ||
                  vm.changedFilterFields.indexOf('ramoISFDR') > indexOfChangedField) {
                let filterRamoISFDROption = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoISFDRProperty);
                vm.pushOptionValue(filterRamoISFDROption,vm.filterOptions.ramoISFDR);
              }
            }
          }

          return null;
        })
        .catch(function(e) {
          console.error(e);
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getProperty: function(propertyList: any, code: string) {
      let res = undefined;
      const regexCode = /^([0-9]+)([a-z]*)/i;
      let codePrefix = undefined;
      let codeSuffix = undefined;
      const codeMatch = regexCode.exec(code);
      let re: any = undefined;
      if (codeMatch) {
        codePrefix = codeMatch[1] || "";
        codeSuffix = codeMatch[2] || "";
        re = new RegExp(`^${codePrefix}\\.[0-9]${codeSuffix}`);
      }
      const p = propertyList.find((p: any) => {
        let match = false;
        const equals = p.code === code;
        if (!equals && re != undefined) {
          match = re.test(p.code);
        }
        return equals || match;
      });
      return p || {};
    },
    retrieveProductsList: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      vm.listaProdottiCensiti = []; //clean
      vm.listaProdottiCensitiForTable = []; //clean

      vm.setDatePropertiesValue();

      const noDashed = true;

      if (vm.$props.filters == undefined) {
        vm.storeFilter();
      }
      const serviceCallReturnValue = await requestService.getProductsList(vm.filtroRicerca,vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.listaProdottiCensiti = result;

          vm.listaProdottiCensiti.sort(function(a: any, b: any) {
            const nameA = a.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            const nameB = b.properties[0].value.toUpperCase(); // ignora maiuscole e minuscole
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            const codeA = a.productCode; // ignora maiuscole e minuscole
            const codeB = b.productCode; // ignora maiuscole e minuscole
            if (codeA < codeB) {
              return -1;
            }
            if (codeA > codeB) {
              return 1;
            }

            return 0;
          });

          const prodotti = vm.listaProdottiCensiti.length;
          if (prodotti > vm.itemsPerPage) {
            const p = prodotti / vm.itemsPerPage;
            vm.totPages = Math.floor(p);
            if (p > vm.totPages) {
              vm.totPages += 1;
            }
          } else {
            vm.totPages = 1;
          }
          vm.needsPagination = vm.totPages > 1;

          let i;
          for (i = 0; i < vm.listaProdottiCensiti.length; i++) {
            if (vm.listaProdottiCensiti[i].properties[0] != undefined) {
              let obj = {} as any;
              obj.id = i;
              obj.isSelected = false;
              obj.isToModify = vm.isAdmin();
              obj.prodottoCompleto = vm.listaProdottiCensiti[i].completed;
              obj.productId = vm.listaProdottiCensiti[i].productId;
              obj.productCode = vm.listaProdottiCensiti[i].productCode;
              obj.prodotto = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodottoProperty));
              obj.piuVersioniProdotto = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.piuVersioniProperty).value;
              obj.codiceProdottiCollegati = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.codProdCollegatiProperty).value;
              obj.compagnia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.compagniaProperty));
              obj.mercato = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.mercatoProperty));
              obj.canale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.canaleProperty));
              obj.distributori = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.distributoriProperty));
              obj.tipologiaProdotto = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaProdottoProperty));
              obj.tipologiaSottostanti = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaSottostantiProperty));
              obj.prodottoInCommercio = vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.prodCommercioProperty).value;
              obj.inizioCommercializzazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.inizioCommProperty));
              obj.fineCommercializzazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.fineCommProperty));
              obj.edizioneDIPAggiuntivo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.edizioneDIPAggProperty));
              obj.tipologiaPremio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaPremioProperty));
              obj.durataContrattuale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.durataContrattoProperty));
              obj.durataPianoPagamentoPremi = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.durataPianoPagamentoPremiProperty));
              obj.importoMinPremioUnico = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.importoMinPremioUnicoProperty));
              obj.importoMaxPremioUnico = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.importoMaxPremioUnicoProperty));
              obj.importoMinPremioRicAnnuo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.importoMinPremioRicAnnuoProperty));
              obj.importoMaxPremioRicAnnuo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.importoMaxPremioRicAnnuoProperty));
              obj.targetMarket = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.targetMarketProperty));
              obj.orizzonteTemporaleSuggerito = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.orizzonteTemporaleSuggeritoProperty, noDashed));
              obj.indicatoreSinteticoRischio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.indicatoreSinteticoRischioProperty, noDashed));
              obj.reductionInYieldCostiIngresso = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.reductionInYieldCostiIngressoProperty, noDashed));
              obj.reductionInYieldCostiUscita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.reductionInYieldCostiUscitaProperty, noDashed));
              obj.reductionInYieldCostiCorrenti = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.reductionInYieldCostiCorrentiProperty, noDashed));
              obj.assetAllocation = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.assetAllocationProperty));
              obj.invMinGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invMinGestioneSeparataProperty));
              obj.invMaxGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invMaxGestioneSeparataProperty));
              obj.gestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.gestioneSeparataProperty));
              obj.rendimentoGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.rendimentoGestioneSeparataProperty, noDashed));
              obj.rendMinGarantito = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.rendMinGarantitoProperty));
              obj.rendMinGarantitoMisura = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.rendMinGarantitoMisuraProperty));
              obj.presenzaConsolidamentoAnnuoRivalutazioniContrattuali = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.presenzaConsolidamentoAnnuoRivalutazioniContrattualiProperty));
              obj.consolidamentoAnnuoRivalutazioniContrattuali = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.consolidamentoAnnuoRivalutazioniContrattualiProperty));
              obj.fondoUtili = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.fondoUtiliProperty));
              obj.invMinRamoIII = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invMinRamoIIIProperty));
              obj.invMaxRamoIII = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invMaxRamoIIIProperty));
              obj.numFondiInterni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.numFondiInterniProperty));
              obj.tipologiaFondiInterni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaFondiInterniProperty));
              obj.numOICRETF = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.numOICRETFProperty));
              obj.presenzaProtezioneCapitale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.presenzaProtezioneCapitaleProperty));
              obj.protezioneCapitale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.protezioneCapitaleProperty));
              obj.opzioniContrattualiTipologia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.opzioniContrattualiTipologiaProperty));
              obj.cedola = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.cedolaProperty));
              obj.decumulo = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.decumuloProperty));
              obj.rendita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.renditaProperty));
              obj.stopLoss = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.stopLossProperty));
              obj.takeProfit = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.takeProfitProperty));
              obj.progressiveInvestment = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.progressiveInvestmentProperty));
              obj.automaticRebalance = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.automaticRebalanceProperty));
              obj.downtrendOpportunity = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.downtrendOpportunityProperty));
              obj.lifeCycle = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.lifeCycleProperty));
              obj.altreOpzioniContrattuali = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.altreOpzioniContrattualiProperty));
              obj.garanzieAssicurativeTipologia = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.garanzieAssicurativeTipologiaProperty));
              obj.maggiorazioneCasoMorteStandard = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMorteStandardProperty));
              obj.maggiorazioneCasoMorteStandardPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMorteStandardPrestazioneProperty, noDashed));
              obj.maggiorazioneCasoMortePerInfortunio = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerInfortunioProperty));
              obj.maggiorazioneCasoMortePerInfortunioPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerInfortunioPrestazioneProperty));
              obj.maggiorazioneCasoMortePerIncidenteStradale = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerIncidenteStradaleProperty));
              obj.maggiorazioneCasoMortePerIncidenteStradalePrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerIncidenteStradalePrestazioneProperty));
              obj.maggiorazioneCasoMortePerMinusvalenza = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerMinusvalenzaProperty));
              obj.maggiorazioneCasoMortePerMinusvalenzaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.maggiorazioneCasoMortePerMinusvalenzaPrestazioneProperty));
              obj.TCMStandAlone = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.TCMStandAloneProperty));
              obj.TCMStandAlonePrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.TCMStandAlonePrestazioneProperty));
              obj.longTermCare = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.longTermCareProperty));
              obj.longTermCarePrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.longTermCarePrestazioneProperty));
              obj.dreadDisease = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.dreadDiseaseProperty));
              obj.dreadDiseasePrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.dreadDiseasePrestazioneProperty));
              obj.invaliditaInabilita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaInabilitaProperty));
              obj.invaliditaInabilitaPrestazione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.invaliditaInabilitaPrestazioneProperty));
              obj.altreGaranzieAssicurative = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.altreGaranzieAssicurativeProperty));
              obj.tipologiaBonusIngresso = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaBonusIngressoProperty));
              obj.bonusIngresso = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.bonusIngressoProperty));
              obj.tipologiaBonusFedelta = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaBonusFedeltaProperty));
              obj.bonusFedelta = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.bonusFedeltaProperty));
              obj.speseEmissione = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseEmissioneProperty));
              obj.tipologiaCaricamentoPIC = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaCaricamentoPICProperty));
              obj.caricamentoPIC = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.caricamentoPICProperty));
              obj.tipologiaCaricamentoPAC = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaCaricamentoPACProperty));
              obj.caricamentoPAC = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.caricamentoPACProperty));
              obj.caricamento = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.caricamentoProperty));
              obj.tipologiaCommissioneGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaCommissioneGestioneSeparataProperty));
              obj.commissioneGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneGestioneSeparataProperty, noDashed));
              obj.tipologiaCommissioneFondiInterni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaCommissioneFondiInterniProperty));
              obj.commissioneFondiInterniAzionari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneFondiInterniAzionariProperty));
              obj.commissioneFondiInterniObbligazionari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneFondiInterniObbligazionariProperty));
              obj.commissioneFondiInterniBilanciati = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneFondiInterniBilanciatiProperty));
              obj.commissioneFondiInterniFlessibili = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneFondiInterniFlessibiliProperty));
              obj.commissioneFondiInterniMonetari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneFondiInterniMonetariProperty));
              obj.commissioneSottostantiFondiInterni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneSottostantiFondiInterniProperty, noDashed));
              obj.tipologiaSpeseGestionePolizzaOICRETF = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.tipologiaSpeseGestionePolizzaOICRETFProperty));
              obj.speseGestionePolizzaOICRETFAzionari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseGestionePolizzaOICRETFAzionariProperty));
              obj.speseGestionePolizzaOICRETFObbligazionari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseGestionePolizzaOICRETFObbligazionariProperty));
              obj.speseGestionePolizzaOICRETFBilanciati = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseGestionePolizzaOICRETFBilanciatiProperty));
              obj.speseGestionePolizzaOICRETFFlessibili = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseGestionePolizzaOICRETFFlessibiliProperty));
              obj.speseGestionePolizzaOICRETFMonetari = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.speseGestionePolizzaOICRETFMonetariProperty));
              obj.commissioneOICRETF = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioneOICRETFProperty, noDashed));
              obj.applicazioneCommissioniOverperformance = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.applicazioneCommissioniOverperformanceProperty, noDashed));
              obj.commissioniOverperformance = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioniOverperformanceProperty));
              obj.costoMaggiorazioneCasoMorteStandard = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.costoMaggiorazioneCasoMorteStandardProperty));
              obj.riscatto = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.riscattoProperty));
              obj.applicazioneCommissioniUscita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.applicazioneCommissioniUscitaProperty));
              obj.commissioniUscita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.commissioniUscitaProperty, noDashed));
              obj.altriCosti = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.altriCostiProperty));
              obj.retrocessioneCaricamento = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrocessioneCaricamentoProperty, noDashed));
              obj.retrocessioneGestioneSeparata = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrocessioneGestioneSeparataProperty, noDashed));
              obj.retrocessioneRamoIII = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.retrocessioneRamoIIIProperty, noDashed));
              obj.note = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.noteProperty));
              obj.sostenibilita = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.sostenibilitaProperty));
              obj.ramoISFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoISFDRProperty));
              obj.ramoITassonomiaUE = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoITassonomiaUEProperty));
              obj.ramoIAllocazioneAttivi = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIAllocazioneAttiviProperty));
              obj.ramoIPAI = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIPAIProperty));
              obj.ramoIIIPresenzaFondiInterniArt8SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPresenzaFondiInterniArt8SFDRProperty));
              obj.ramoIIINumFondiInterniArt8SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIINumFondiInterniArt8SFDRProperty));
              obj.ramoIIIFondiInterniArt8SFDRPerc = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIFondiInterniArt8SFDRPercProperty));
              obj.ramoIIITassonomiaUEFondiInterniArt8 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIITassonomiaUEFondiInterniArt8Property));
              obj.ramoIIIAllocazioneAttiviFondiInterniArt8 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIAllocazioneAttiviFondiInterniArt8Property));
              obj.ramoIIIPresenzaFondiInterniArt9SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPresenzaFondiInterniArt9SFDRProperty));
              obj.ramoIIINumFondiInterniArt9SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIINumFondiInterniArt9SFDRProperty));
              obj.ramoIIIFondiInterniArt9SFDRPerc = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIFondiInterniArt9SFDRPercProperty));
              obj.ramoIIITassonomiaUEFondiInterniArt9 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIITassonomiaUEFondiInterniArt9Property));
              obj.ramoIIIAllocazioneAttiviFondiInterniArt9 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIAllocazioneAttiviFondiInterniArt9Property));
              obj.ramoIIIPAIFondiInterni = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPAIFondiInterniProperty));
              obj.ramoIIIPresenzaOICRETFArt8SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPresenzaOICRETFArt8SFDRProperty));
              obj.ramoIIINumOICRETFArt8SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIINumOICRETFArt8SFDRProperty));
              obj.ramoIIIOICRETFArt8SFDRPerc = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIOICRETFArt8SFDRPercProperty));
              obj.ramoIIITassonomiaUEOICRETFArt8 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIITassonomiaUEOICRETFArt8Property));
              obj.ramoIIIPresenzaOICRETFArt9SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPresenzaOICRETFArt9SFDRProperty));
              obj.ramoIIINumOICRETFArt9SFDR = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIINumOICRETFArt9SFDRProperty));
              obj.ramoIIIOICRETFArt9SFDRPerc = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIOICRETFArt9SFDRPercProperty));
              obj.ramoIIITassonomiaUEOICRETFArt9 = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIITassonomiaUEOICRETFArt9Property));
              obj.ramoIIIPAIOICRETF = vm.printVersatileValues(vm.getProperty(vm.listaProdottiCensiti[i].properties, codes.ramoIIIPAIOICRETFProperty));

              vm.listaProdottiCensitiForTable.push(obj);
            }
          }

          vm.listaProdottiCensitiPaginati = [];
          for (let i = 0; i < vm.totPages; i++) {
            const s = vm.itemsPerPage * i;
            const e = vm.itemsPerPage * (i + 1);
            const sliced = vm.listaProdottiCensitiForTable.slice(s, e);
            vm.listaProdottiCensitiPaginati.push(sliced);
          }

          vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[0];

          return null;
        })
        .catch(function(e) {
          console.error(e);
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },
    getPropertyValues: async function() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");

      const serviceCallReturnValue = await requestService.getPropertyValues(vm.codCategoriaProdotto)
        .then(handleResponse)
        .then((result: any) => {
          vm.prodottiOptions = result.prodotti;
          vm.distributoriOptions = result.distributori;
          vm.compagnieOptions = result.compagnie;
        })
        .catch(function(e) {
          console.error(e);
          vm.openModalError("Errore generico");
        });

      vm.$loadingService.stopLoading("loading");
    },    
    inizializzaFiltroRicerca: function() {
      const vm = this as any;

      let filter = this.$props.filters;
      if (filter == undefined) {
        filter = vm.getStoredFilter();
      }

      if (filter == undefined) {
        vm.filtroRicerca.prodottoCompleto = null;
        vm.filtroRicerca.prodotto = [] as any;      
        vm.filtroRicerca.compagnia = [] as any;
        vm.filtroRicerca.mercato = [] as any;
        vm.filtroRicerca.canale = [] as any;
        vm.filtroRicerca.distributori = [] as any;
        vm.filtroRicerca.tipologiaProdotto = [] as any;
        vm.filtroRicerca.tipologiaSottostanti = [] as any;
        vm.filtroRicerca.prodottoInCommercio = null;
        vm.filtroRicerca.inizioCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneADate = undefined;
        vm.filtroRicerca.fineCommercializzazioneDaDate = undefined;
        vm.filtroRicerca.fineCommercializzazioneADate = undefined;
        vm.filtroRicerca.inizioCommercializzazioneDa = undefined;
        vm.filtroRicerca.inizioCommercializzazioneA = undefined;
        vm.filtroRicerca.fineCommercializzazioneDa = undefined;
        vm.filtroRicerca.fineCommercializzazioneA = undefined;
        vm.filtroRicerca.tipologiaPremio = [] as any;
        vm.filtroRicerca.impMinPremioUnicoDa = undefined;
        vm.filtroRicerca.impMinPremioUnicoA = undefined;
        vm.filtroRicerca.impMinPremioRicorrenteDa = undefined;
        vm.filtroRicerca.impMinPremioRicorrenteA = undefined;
      } else {
        vm.filtroRicerca = filter;
      }
    },
    pushOptionValue(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value) && filterOptionToInsert.value != vm.ND) {
        filter.push({ code : filterOptionToInsert.code , description : filterOptionToInsert.value })
      }
    },
    pushOptionValueProdotto(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      let isOptionPresent = false;
      filter.forEach((o: any) => {
        if (o.description == filterOptionToInsert.value) {
          isOptionPresent = true;
        }
      });
      if (!isOptionPresent && !vm.isEmptyOrSpaces(filterOptionToInsert.value)) {
        filter.push({ code : filterOptionToInsert.code + "_" + filterOptionToInsert.value , description : filterOptionToInsert.value });
      }
    },
    pushOptionValues(filterOptionToInsert: any, filter: any) {
      const vm = this as any;

      filterOptionToInsert.values.forEach((v: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.code == v.code && o.description == v.description) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent) {
          filter.push({ code : v.code , description : v.description })
        }
      });
    },
    pushOptionStringList(filterOptionToInsert: any, filter: any, fieldName: string) {
      const vm = this as any;

      filterOptionToInsert.stringList.forEach((s: any) => {
        let isOptionPresent = false;
        filter.forEach((o: any) => {
          if (o.description == s.value) {
            isOptionPresent = true;
          }
        });
        if (!isOptionPresent && !vm.isEmptyOrSpaces(s.value)) {
          let index = filter.length;
          filter.push({ code : categories.VITA_INVESTIMENTO + "-" + fieldName + "-" + index, description : s.value });
        }
      });
    },
    homeProdotti: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      if (vm.fromDashboard) {
        vm.dashboardVitaInvestimento();
      } else {
        vm.$router.go(-1);
      }
    },
    dashboardVitaInvestimento: function() {
      const vm = this as any;
      const isAdvanced = vm.isAdvanced() || vm.isAdmin();
      if (!isAdvanced || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-vita-investimento', params: {user: vm.loggedUser, fromDatabase: true}});
    },
    stringify: function(value: string) {
      if (value == undefined ||
          value == null) {
        return "";
      }

      return value;
    },
    setIsSelected: function(index: number) {
      const vm = this as any;
      vm.listaProdottiCensitiForTable[index].isSelected = !vm.listaProdottiCensitiForTable[index].isSelected;
      if (!vm.listaProdottiCensitiForTable[index].isSelected) {
        vm.selectAll = false;
        jquery('#isSelectedAll').prop('checked', false);
      }
    },
    setIsSelectedAll: function() {
      const vm = this as any;
      vm.selectAll = !vm.selectAll;
      vm.listaProdottiCensitiForTable.forEach(function (c: any) {
        c.isSelected = vm.selectAll;
      });
      jquery('.selectProd').prop('checked', vm.selectAll);
    },
    isCompleted: function(index: number) {
      const vm = this as any;
      return vm.listaProdottiCensitiForTable[index].prodottoCompleto ? "Sì" : "No";
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      vm.filtroRicerca.inizioCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneDaDate);
      vm.filtroRicerca.inizioCommercializzazioneA = vm.formatDate(vm.filtroRicerca.inizioCommercializzazioneADate);
      vm.filtroRicerca.fineCommercializzazioneDa = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneDaDate);
      vm.filtroRicerca.fineCommercializzazioneA = vm.formatDate(vm.filtroRicerca.fineCommercializzazioneADate);
    },
    exportExcel: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let csvName = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractXlsx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            csvName = 'product-export.xlsx';          
            vm.downloadDocFromBlob(blob, csvName, contentType);
          })
          .catch((e) => {
            console.error(e);
            vm.openModalError("Errore generico");
          })
      }

      vm.stopLoading();
    },
    exportPptx: async function() {
      const vm = this as any;
      vm.startLoading();

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected &&
            vm.listaProdottiCensitiForTable[i].prodottoCompleto) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      if (productIdsFilter.length <= 0) {
        vm.openModalError("Non verrà estratto alcun prodotto in quanto nessun prodotto selezionato è completo");
      } else {
        let contentType = '';
        let filename = '';
        const filtro = vm.filtroRicerca;
        filtro.ids = productIdsFilter;
        filtro.categoriaProdotto = vm.codCategoriaProdotto;
        const serviceCallReturnValue = await requestService
          .extractPptx(filtro)
          .then((response: any) => {
            const headerContentType = response.headers.get("content-type");
            contentType = headerContentType !== null ? headerContentType : 'application/octet-stream';
            return response.blob();
          })
          .then((blob: any) => {
            filename = 'product-export.pptx';
            vm.downloadDocFromBlob(blob, filename, contentType);
          })
          .catch((e) => {
            console.error(e);
            vm.openModalError("Errore generico");
          })
      }

      vm.stopLoading();
    },
    downloadDocFromBlob(blob: any, name: string, contentType: string) {
      const newBlob = new Blob([blob], { type: contentType });

      // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob, name);
      } else {
        // For other browsers: create a link pointing to the ObjectURL containing the blob.
        const objUrl = window.URL.createObjectURL(newBlob);

        const link = document.createElement('a');
        link.href = objUrl;
        link.target = '_blank';
        link.download = name;
        link.click();

        // For Firefox it is necessary to delay revoking the ObjectURL.
        setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
      }
    },
    addProduct: async function() {
      const vm = this as any;

      vm.$router.push({ name: 'vita-investimento', params: {user: vm.loggedUser}});
    },
    modifyProduct: async function(row: any) {
      const vm = this as any;

      const productIdsFilter = [] as any;
      if (row !== undefined) {
        productIdsFilter.push(vm.listaProdottiCensitiForTable[row].productId);
      } else {
        let i;
        for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
          if (vm.listaProdottiCensitiForTable[i].isSelected) {
            productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
          }
        }
      }

      let productIdToModify = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da modificare.");
      } else {
        productIdToModify = productIdsFilter[0];
        vm.$router.push({ name: 'vita-investimento', params: {user: vm.loggedUser, productId: productIdToModify}});
      }
    },
    showProduct: async function(row: any) {
      const vm = this as any;

      let p = null as any;
      let op = null as any;
      const productFilter = [] as any;
      if (row !== undefined) {
        p = vm.listaProdottiCensitiForTable[row];
        op = vm.listaProdottiCensiti[row];
      }

      if (p == null) {
        vm.openModalError("Selezionare un solo prodotto da visualizzare.");
      } else {
        vm.product = p;
        vm.productName = null;
        if (op !== undefined && op !== null) {
          vm.productName = op.properties[0].value;
        }
        if (vm.productName === undefined || vm.productName === null) {
          vm.productName = vm.product.prodotto;
        }
        vm.$bvModal.show("modal-show");
      }
    },
    showSectionName: function(col: any) {
      const vm = this as any;

      return col.sectionName !== undefined || col.field == 'note';
    },
    showProductValue: function(col: any) {
      const vm = this as any;

      if (col.checkVisibile && !vm.isAdmin()) {
        return false;
      }

      const field = col.field;
      if (field == 'isSelected' || field == 'isToModify' || field == 'prodottoCompleto' || field == 'productCode') {
        return false;
      }

      if (vm.product[field] == undefined) {
        return false;
      }

      let value = vm.getProductValue(field);

      let isNoteFieldEmpty = false;
      if (field == 'note' && vm.isEmptyOrSpaces(value)) {
        isNoteFieldEmpty = true;
      }

      return value != vm.ND && value != "<div></div>" && value != "<div>"+vm.ND+"</div>" && !col.modalShowHidden && !isNoteFieldEmpty;
    },
    getProductValue: function(field: any) {
      const vm = this as any;

      let v = vm.product[field];

      let value = '';
      if (v.printableModalValue != undefined && v.printableModalValue != '') {
        value = v.printableModalValue;
      } else if (v.printableValue != undefined && v.printableValue != '') {
        value = v.printableValue;
      } else if (v.printableModalValue == undefined && v.printableValue == undefined) {
        value = v;
      }

      return value;
    },
    existsOneFieldOfSectionNotND: function(sectionName: string) {
      const vm = this as any;

      let isReachedSectionName = false;
      let isReachedNextSectionName = false;
      let existsOneFieldOfSectionNotND = false;
      vm.columns.forEach((col: any) => {
        if (isReachedSectionName && col.sectionName !== undefined) {
          isReachedNextSectionName = true;
        }
        if (!isReachedSectionName && col.sectionName == sectionName) {
          isReachedSectionName = true;
        }
        if (isReachedSectionName && !isReachedNextSectionName) {
          existsOneFieldOfSectionNotND = existsOneFieldOfSectionNotND || vm.showProductValue(col);
        }
      });

      return existsOneFieldOfSectionNotND;
    },
    confirmDuplicateProduct() {
      const vm = this as any;

      vm.operationToConfirm = "DUPLICATE";
      vm.openModalConfirmOperation("Si conferma di voler clonare il prodotto?");
    },    
    duplicateProduct: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      let productIdToDuplicate = "";
      if (productIdsFilter.length != 1) {
        vm.openModalError("Selezionare un solo prodotto da duplicare.");
      } else {
        productIdToDuplicate = productIdsFilter[0];

        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .duplicateProduct({productId : productIdToDuplicate})
          .then(handleResponse)
          .then((result: any) => {
            vm.stopLoading();
            vm.openModalSuccess("Duplicazione prodotto avvenuta con successo (productCode = " + result.productCode + ")");
            vm.retrieveProductsList();
            return null;
          })
          .catch((e) => {
            console.error(e);
            vm.openModalError("Errore generico");
          })
      }
    },
    confirmDeleteProductsList() {
      const vm = this as any;

      vm.operationToConfirm = "DELETE";
      vm.openModalConfirmOperation("Si conferma di voler eliminare il prodotto?");
    },
    deleteProductsList: async function() {
      const vm = this as any;

      const productIdsFilter = [] as any;
      let i;
      for (i = 0; i < vm.listaProdottiCensitiForTable.length; i++) {
        if (vm.listaProdottiCensitiForTable[i].isSelected) {
          productIdsFilter.push(vm.listaProdottiCensitiForTable[i].productId);
        }
      }

      vm.startLoading();

      const serviceCallReturnValue = await requestService.deleteProductsList({ids : productIdsFilter})
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.openModalSuccess("Eliminazione prodotti avvenuta con successo.");
          vm.retrieveProductsList();
          return null;
        })
        .catch((e) => {
          console.error(e);
          vm.openModalError("Errore generico");
        })
    },
    _compare: function(a: any, b: any) {
      const aCode = a.code;
      const bCode = b.code;
      if (aCode === undefined || bCode === undefined) {
        if (bCode !== undefined) {
          return -1;
        }
        if (aCode !== undefined) {
          return 1;
        }
        return 0;
      }

      let aSplit = aCode.split(".");
      let bSplit = bCode.split(".");
      if (aSplit.length > 1 && bSplit.length > 1) {
        let aPre = parseInt(aSplit[0]);
        let aPost = parseInt(aSplit[1]);
  
        let bPre = parseInt(bSplit[0]);
        let bPost = parseInt(bSplit[1]);

        if (aPre == bPre) {
          if (aPost < bPost) {
            return -1;
          }
          if (aPost > bPost) {
            return 1;
          }
          return 0;
        } else if (aPre < bPre) {
          return -1;
        } else {
          return 1;
        }
      }

      if (aCode < bCode) {
        return -1;
      }
      if (aCode > bCode) {
        return 1;
      }
      return 0;
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    printStringListItem(item: any) {
      const vm = this as any;

      let spacing = '';
      if (item.valueSign !== undefined && item.valueSign !== null) {
        spacing = (item.valueSignLeft || item.valueSign.indexOf('ann')) >= 0 ? ' ' : '';
      }

      let stringListItem = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ? item.valueLabel + " " : "");
      if (item.valueSignLeft) {
        stringListItem += item.valueSign + spacing + item.value;
      } else {
        stringListItem += item.value + spacing + item.valueSign;
      }

      return stringListItem;
    },
    clean(s: any) {
      let str = s;
      str = str.replace(/'/g, "&apos;");
      str = str.replace(/"/g, "&quot;");
      return str;
    },
    printVersatileValues(property: any, noDashed: boolean) {
      const vm = this as any;

      let printableValue = "";
      let tooltipValue = "";
      let printableModalValue = "";

      if (property === undefined || property == null) {
        return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
      }

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          property.values.sort(this._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            const s = vm.splitString(item.description);
            printableValue = s[0];
            tooltipValue = s[1];
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let lis: any[] = [];
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              lis.push("<li>" + item.description + "</li>");
              return "<li>" + vm.clean(item.description) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
            if (liCounter > maxLi) {
              tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
            }
          }
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          const s = vm.splitString(vm.printStringListItem(item));
          printableValue = s[0];
          tooltipValue = s[1];
        } else if (noDashed === undefined || !noDashed) {
          const maxLi = 3;
          let liCounter = 0;
          let lis: any[] = [];
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            let valueLabel = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ) ? item.valueLabel + " " : "";
            liCounter++;
            lis.push("<li>" + valueLabel + item.value + item.valueSign + "</li>");
            return "<li>" + vm.clean(valueLabel + item.value + item.valueSign) + "</li>";
          }).join("");

          if (liCounter > maxLi) {
            let spliced = lis.splice(0, maxLi);
            const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
            spliced[maxLi-1] = s;
            li = spliced.join("");
          } else {
            li = lis.join("");
          }

          printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
          if (liCounter > maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
          }
        } else if (noDashed) {
          let equalValues = (property.stringList.length == 2 && property.stringList[0].value == property.stringList[1].value && property.stringList[0].valueSign == property.stringList[1].valueSign && property.name != "Rendimento Gestione Separata");
          if (equalValues) {
            let str;
            if (property.stringList[0].valueSignLeft) {
              str = property.stringList[0].valueSign + " " + property.stringList[0].value;
            } else {
              const spacing = property.stringList[0].valueSign.indexOf('ann') >= 0 ? ' ' : '';
              str = property.stringList[0].value + spacing + property.stringList[0].valueSign;
            }

            const s = vm.splitString(str);
            printableValue = s[0];
            tooltipValue = s[1];
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            let lis: any[] = [];
            let splitted = false;
            // printableValue & tooltipValue
            const tooltipLi = property.stringList.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              const printableStringListItem = vm.printStringListItem(item);
              if (printableStringListItem === "") {
                return "";
              }

              liCounter++;
              const s = vm.splitString(printableStringListItem);
              if (s[0].match(new RegExp("<div>", "g")).length > 1) {
                splitted = true;
                lis.push("<li>" + s[0] + "</li>");
              } else {
                lis.push("<li>" + printableStringListItem + "</li>");
              }

              return "<li>" + vm.clean(printableStringListItem) + "</li>";
            }).join("");

            if (liCounter > maxLi) {
              let spliced = lis.splice(0, maxLi);
              const s = spliced[maxLi-1].replace(/<li>(.+)<\/li>/i, "<li>$1 ...</li>");
              spliced[maxLi-1] = s;
              li = spliced.join("");
            } else {
              li = lis.join("");
            }

            printableValue = "<ul class='nodashed'>" + li + "</ul>";
            if (liCounter > maxLi || splitted) {
              tooltipValue = "<div><ul class=\"nodashed\">" + tooltipLi + "</ul></div>";
            }
          }
        }
      } else if (property.type == propertyTypes.RANGE_FLEX) {
        let isNestedRangeValuesFlex = false;

        if (property.rangeValuesFlex.length > 0) {

          let totItems = 0;
          property.rangeValuesFlex.forEach((item: any) => {
            totItems += 1; // contributo elemento lista property.rangeValuesFlex
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                totItems += 1 + item.rangeValuesFlex.length; // 1 è la label fissa che fa riga a sè stante
              }
            }
          });

          const maxLi = 3;
          let liCounter = 0;
          let liItemsPV = "";
          let liItemsTV = "";
          property.rangeValuesFlex.forEach((item: any) => {
            liCounter++;

            const label = (item.label !== undefined && !vm.isEmptyOrSpaces(item.label)) ? item.label + " " : "";

            const spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
            const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
            
            const spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
            const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;

            let value = undefined;
            if (item.showValue) {
              const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
              value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
            }
            // liItem
            let liItem =  label + from + " " + item.fromToOperator + " " + to;
            if (value !== undefined) {
              liItem +=  " " + item.toValueOperator + " " + value;
            }
            // printableValue
            let s = liItem;
            if (liCounter == maxLi && property.rangeValuesFlex.length > maxLi) {
              s += " ...";
            }
            if (liCounter <= maxLi || totItems == maxLi) {
              liItemsPV += "<li>" + s + "</li>";
            }
            // tooltipValue
            liItemsTV += "<li>" + vm.clean(liItem) + "</li>";

            // L2
            let liItemsPVL2 = "";
            let liItemsTVL2 = "";
            const noDashSpace = "&nbsp;&nbsp;&nbsp;&nbsp;";
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                isNestedRangeValuesFlex = true;

                item.rangeValuesFlex.forEach(function(itemL2: any) {
                  liCounter++;

                  const isLabelL2 = (itemL2.label !== undefined && !vm.isEmptyOrSpaces(itemL2.label));
                  const labelL2 = isLabelL2 ? "-&nbsp;&nbsp;" + itemL2.label + " " : "";

                  const spacingFromL2 = itemL2.fromSignLeft || itemL2.fromSign.indexOf('ann') >= 0 ? ' ' : '';
                  const fromL2 = itemL2.fromSignLeft ? itemL2.fromSign + spacingFromL2 + itemL2.from : itemL2.from + spacingFromL2 + itemL2.fromSign;

                  const spacingToL2 = itemL2.toSignLeft || itemL2.toSign.indexOf('ann') >= 0 ? ' ' : '';
                  const toL2 = itemL2.toSignLeft ? itemL2.toSign + spacingToL2 + itemL2.to : itemL2.to + spacingToL2 + itemL2.toSign;

                  let valueL2 = undefined;
                  if (itemL2.showValue) {
                    const spacingValueL2 = itemL2.valueSignLeft || itemL2.valueSign.indexOf('ann') >= 0 ? ' ' : '';
                    valueL2 = itemL2.valueSignLeft ? itemL2.valueSign + spacingValueL2 + itemL2.value : itemL2.value + spacingValueL2 + itemL2.valueSign;
                  }
                  let liItemL2 = fromL2 + " " + itemL2.fromToOperator + " " + toL2;
                  if (valueL2 !== undefined) {
                    liItemL2 +=  " " + itemL2.toValueOperator + " " + valueL2;
                  }
                  // printableValue L2
                  if (liCounter < maxLi || totItems == maxLi) {
                    if (isLabelL2 && liCounter < maxLi) {
                      liItemsPVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                      liCounter++;
                    }
                  }
                  let s = noDashSpace + liItemL2;
                  if (liCounter == maxLi) {
                    s += " ...";
                  }
                  if (liCounter <= maxLi || totItems == maxLi) {
                    liItemsPVL2 += "<li>" + s + "</li>";
                  }
                  // tooltipValue L2
                  liItemsTVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                  liItemsTVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                });

                liItemsPV += "<div><ul class='nodashed'>" + liItemsPVL2 + "</ul></div>";

                liItemsTV += "<div><ul class=\"nodashed\">" + liItemsTVL2 + "</ul></div>";
              }
            }
          });

          let dashClass = "nodashed";
          if (isNestedRangeValuesFlex) {
            dashClass = "dashed";
          }

          printableValue = "<div><ul class='" + dashClass + "'>" + liItemsPV + "</ul></div>";
          if (liCounter > maxLi) {
            tooltipValue = "<div><ul class=\"" + dashClass + "\">" + liItemsTV + "</ul></div>";
          }
        } else {
          if (property.valueSign !== undefined && property.valueSign !== null) {
            if (property.valueSign.length > 0) {
              printableValue = property.value + property.valueSign;
            }
          }
          if (printableValue === undefined || vm.isEmptyOrSpaces(printableValue)) {
            printableValue = property.value;
          }
          
          const s = vm.splitString(printableValue);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          const s = vm.splitString(property.value);
          printableValue = s[0];
          tooltipValue = s[1];
        }
      } else if (property.value !== undefined && property.value !== null) {
        const s = vm.splitString(vm.printWithSign(property));
        printableValue = s[0];
        tooltipValue = s[1];
      }

      if (tooltipValue !== undefined && !this.isEmptyOrSpaces(tooltipValue)) {
        printableModalValue = tooltipValue;
        tooltipValue = vm.escapeHtml(tooltipValue);
      }

      return {printableValue:printableValue,tooltipValue:tooltipValue,printableModalValue:printableModalValue};
    },
    printNewLine(s: any) {
      if (s !== undefined) {
        return s
          .replace(/\n/g, "<br/>")
          .replace(/\'/g, "&rsquo;")
        ;
      }

      return s;
    },
    splitString(str: any) {
      const vm = this as any;

      const maxRows = 3;
      const maxCharsPerRow = 40;
      let printableValue = "";
      let tooltipValue = "";

      if (str === undefined) {
        return [printableValue, tooltipValue];
      }

      let brArray = str.split("\n");
      let brDiv = [] as any;
      brArray.forEach((item: any) => {
        let itemWords = item.split(" ");
        let concatWords = "";
        for (let i = 0; i < itemWords.length; i++) {
          let word = itemWords[i];
          if (i == 0) {
            concatWords = word;
          } else {
            if ((concatWords + word).length < maxCharsPerRow) {
              concatWords = concatWords + " " + word;
            } else {
              brDiv.push(concatWords);
              concatWords = word;
            }
          }

          // gestione last element
          if (i+1 == itemWords.length) {
            brDiv.push(concatWords);	
          }
        }
      });

      let flagDots = false;
      if (brDiv.length > maxRows) {
        flagDots = true;
        for (let i = 0; i < maxRows; i++) {
          let s = brDiv[i];
          if (i == maxRows - 1) {
            s += " ...";
          }
          printableValue += "<div>" + s + "</div>";
        }
      } else {
        for (let i = 0; i < brDiv.length; i++) {
          printableValue += "<div>" + brDiv[i] + "</div>";
        }
      }

      if (flagDots) {
        tooltipValue = vm.printNewLine(str);
      }

      return [printableValue, tooltipValue];
    },
    printString: function(prop: any) {
      const vm = this as any;
      let retValue = undefined;
      if (prop.valueSign !== undefined && prop.valueSign !== null) {
        retValue = prop.valueSignLeft ? prop.valueSign + " " + prop.value : prop.value + prop.valueSign;
      } else {
        retValue = prop.value;
      }

      if (retValue === undefined || retValue === null || retValue === "") {
        return retValue;
      }

      const z = vm.printNewLine(retValue);
      return z;
    },
    printWithSign(property: any) {
      const vm = this as any;

      const value = vm.stringify(property.value);
      if (value != '' && value != vm.ND) {
        const sign = vm.stringify(property.valueSign !== undefined ? property.valueSign : "");

        const spacing = property.valueSignLeft || sign.indexOf('ann') >= 0 ? ' ' : '';

        if (property.valueSignLeft) {
          return sign + spacing + value;
        }
        return value + spacing + sign;
      }

      return value;
    },
    printRangeValuesFlexItem(item: any, rangeValuesFlex: any) {
      const vm = this as any;

      let spaceLabel = " ";
      if (rangeValuesFlex !== undefined && rangeValuesFlex !== null) {
        if (rangeValuesFlex[0].label !== undefined && !vm.isEmptyOrSpaces(rangeValuesFlex[0].label) && vm.isEmptyOrSpaces(item.label)) {
          spaceLabel = " ".repeat(rangeValuesFlex[0].label.length + 1);
        }
      }
      const label = (item.label !== undefined && item.label !== null) ? item.label + spaceLabel : "";

      let spacingFrom = undefined;
      if (item.fromSign !== undefined && item.fromSign !== null) {
        spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
      }

      let spacingTo = undefined;
      if (item.toSign !== undefined && item.toSign !== null) {
        spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
      }

      const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
      const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;
      let value = undefined;
      if (item.showValue && item.valueSign !== null) {
        const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
        value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
      }

      const retValue = label + from + " " + item.fromToOperator + " " + to + (item.showValue ? (" " + item.toValueOperator + " " + value) : "");

      return retValue;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    openModalSuccess(msg: string) {
      const vm = this as any;
      vm.msgSuccess = msg;
      vm.$bvModal.show("modal-success");
    },
    closeModalSuccess() {
      const vm = this as any;
      vm.$bvModal.hide("modal-success");
    },
    onClickReturnSuccess() {
      const vm = this as any;
      vm.closeModalSuccess();
    },
    openModalError(msg: string) {
      const vm = this as any;
      vm.msgError = msg;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    openModalConfirmOperation(msg: string) {
      const vm = this as any;
      vm.msgConfirmOperation = msg;
      vm.$bvModal.show("modal-confirm-operation");
    },
    closeModalConfirmOperation() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-operation");
    },
    onClickReturnConfirmOperation() {
      const vm = this as any;
      if (vm.operationToConfirm == "DELETE") {
        vm.deleteProductsList();
      } else if (vm.operationToConfirm == "DUPLICATE") {
        vm.duplicateProduct();
      }
      vm.operationToConfirm == "";
      vm.closeModalConfirmOperation();
    },
    closeModalShow() {
      const vm = this as any;
      vm.$bvModal.hide("modal-show");
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('admin-view') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0;
      }
      return false;
    },
    noDashboard: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('no-dashboard') >= 0;
      }
      return false;
    },
    isModifyProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('modifica-prodotto') >= 0;
      }
      return false;
    },
    isDuplicateProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('duplica-prodotto') >= 0;
      }
      return false;
    },
    isDeleteProduct: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('elimina-prodotto') >= 0;
      }
      return false;
    },
    prepareJqueryEvents: function() {
      const vm = this as any;

      vm.destroyJqueryEvents();

      jquery("div.dataTables_scrollFoot").hide();

      (jquery('[data-toggle="tooltip"]') as any).tooltip();

      vm.scrollTables = jquery("div.dataTables_scrollHead, div.dataTables_scrollBody");

      jquery(".selectProd").on("click", vm.selectProdClick);
      jquery(".modifyProd").on("click", vm.modifyProdClick);
      jquery(".showProd").on("click", vm.showProdClick);

      jquery(".multiheader[colspan='1']").addClass('force-width');
      jquery(".multiheader[colspan='1'] > div").addClass('force-width');

      if (vm.selectAll) {
        // nel caso in cui cambi "pagina" della tabella con selectAll = true
        jquery('.selectProd').prop('checked', vm.selectAll);
      }
    },
    destroyJqueryEvents: function() {
      const vm = this as any;

      (jquery('[data-toggle="tooltip"]') as any).tooltip('dispose');

      jquery(".selectProd").off("click", vm.selectProdClick);
      jquery(".modifyProd").off("click", vm.modifyProdClick);
      jquery(".showProd").off("click", vm.showProdClick);
    },
    scrollTo: function(id: string) {
      const vm = this as any;

      const elementToScrollTo = jquery('#' + id);
      if (elementToScrollTo != undefined && elementToScrollTo.offset() != undefined) {
        const offset = elementToScrollTo.offset();

        const body = jquery("div.dataTables_scrollBody");
        var bodyLeft = body.scrollLeft();
        if (bodyLeft == undefined) {
          bodyLeft = 0;
        }

        if (offset != undefined) {
          const offsetLeft = offset.left - 50;
          vm.scrollTables.scrollLeft(bodyLeft + offsetLeft, 0);
        }
      }
    },
    selectProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isSelectedProd_'.length);
        vm.setIsSelected(id);
      }
    },
    modifyProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToModifyProd_'.length);
        (jquery('#'+event.currentTarget.id) as any).tooltip('dispose');
        vm.modifyProduct(id);
      }
    },
    showProdClick: function(event: any) {
      const vm = this as any;
      if (event && event.currentTarget && event.currentTarget.id) {
        const id = event.currentTarget.id.substr('isToShowProd_'.length);
        vm.showProduct(id);
      }
    },
    escapeHtml(value: string) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    handlePageInput(val: number) {
      const vm = this as any;
      vm.page = val;
      vm.listaProdottiCensitiCurrent = vm.listaProdottiCensitiPaginati[val-1];
      
      const sizeLastPage = (vm.page - 1)*vm.itemsPerPage;
      vm.pageStart = sizeLastPage + 1;
      vm.pageEnd = sizeLastPage + vm.listaProdottiCensitiCurrent.length;
    },
  },
  mounted() {
    const vm = this as any;

    if (!vm.loggedUser) {
      vm.homeProdotti();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('vita-investimento') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.homeProdotti();
      }
    }

    vm.columns.forEach(function (c: any) {
      if (!c.orderable) {
        c.orderable = false;
      }
      if (c.checkVisible) {
        c.visible = vm.isAdmin();
      }
    });
  },
  beforeDestroy() {
    const vm = this as any;

    vm.destroyJqueryEvents();
  },
  created() {
    if (!this.isAdmin()) {
      //this.options.fixedColumns.leftColumns = 5; // prodotto (vanno contate anche quelle non visibili per ruolo)
      this.options.fixedColumns.leftColumns = 0;
    } else {
      this.options.fixedColumns.leftColumns = 0;
    }

    this.inizializzaFiltroRicerca();

    this.getPropertyValues()
      .then(result => {
        this.resetFilterOptions();
      });

    this.retrieveProductsList();
  }
});
